export class AvatarAPI {
  static get baseUrl() {
    return process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_API_BASE_URL
      : process.env.REACT_APP_API_BASE_URL;
  }
  static createAvatar() {
    return {
      method: "POST",
      url: this.baseUrl + "/avatars",
    };
  }

  static getAvatar(id: string) {
    return {
      method: "GET",
      url: this.baseUrl + "/avatars/" + id,
    };
  }
}
